// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  FrontEndMessage,
  FrontEndMessageT,
  verifyFrontEndMessage,
} from "../front-end/front-end-message";

export class BatchedFrontEndMessage implements flatbuffers.IUnpackableObject<BatchedFrontEndMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BatchedFrontEndMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBatchedFrontEndMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: BatchedFrontEndMessage,
  ): BatchedFrontEndMessage {
    return (obj || new BatchedFrontEndMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsBatchedFrontEndMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: BatchedFrontEndMessage,
  ): BatchedFrontEndMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BatchedFrontEndMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  timestamp(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  messages(index: number, obj?: FrontEndMessage): FrontEndMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new FrontEndMessage()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  messagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startBatchedFrontEndMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addTimestamp(builder: flatbuffers.Builder, timestamp: bigint) {
    builder.addFieldInt64(0, timestamp, 0n);
  }

  static addMessages(builder: flatbuffers.Builder, messagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messagesOffset, 0);
  }

  static createMessagesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startMessagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endBatchedFrontEndMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // messages
    return offset;
  }

  static finishBatchedFrontEndMessageBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset);
  }

  static finishSizePrefixedBatchedFrontEndMessageBuffer(
    builder: flatbuffers.Builder,
    offset: flatbuffers.Offset,
  ) {
    builder.finish(offset, undefined, true);
  }

  static createBatchedFrontEndMessage(
    builder: flatbuffers.Builder,
    timestamp: bigint,
    messagesOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    BatchedFrontEndMessage.startBatchedFrontEndMessage(builder);
    BatchedFrontEndMessage.addTimestamp(builder, timestamp);
    BatchedFrontEndMessage.addMessages(builder, messagesOffset);
    return BatchedFrontEndMessage.endBatchedFrontEndMessage(builder);
  }

  unpack(): BatchedFrontEndMessageT {
    return new BatchedFrontEndMessageT(
      this.timestamp(),
      this.bb!.createObjList<FrontEndMessage, FrontEndMessageT>(
        this.messages.bind(this),
        this.messagesLength(),
      ),
    );
  }

  unpackTo(_o: BatchedFrontEndMessageT): void {
    _o.timestamp = this.timestamp();
    _o.messages = this.bb!.createObjList<FrontEndMessage, FrontEndMessageT>(
      this.messages.bind(this),
      this.messagesLength(),
    );
  }

  unpackFields(...fields: string[]): BatchedFrontEndMessageT {
    const t = new BatchedFrontEndMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("timestamp")) {
      t.timestamp = this.timestamp();
    }
    if (fieldSet.has("messages")) {
      t.messages = this.bb!.createObjList<FrontEndMessage, FrontEndMessageT>(
        this.messages.bind(this),
        this.messagesLength(),
      );
    }
    return t;
  }
}

export class BatchedFrontEndMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public timestamp: bigint = 0n,
    public messages: FrontEndMessageT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.messages === null || this.messages === undefined) {
      throw new Error('Required field "messages" is not set');
    }
    const messages = BatchedFrontEndMessage.createMessagesVector(
      builder,
      builder.createObjectOffsetList(this.messages),
    );

    return BatchedFrontEndMessage.createBatchedFrontEndMessage(builder, this.timestamp, messages);
  }

  clone(): BatchedFrontEndMessageT {
    const obj = new BatchedFrontEndMessageT();
    obj.timestamp = this.timestamp;
    obj.messages = this.messages.map((e) => e.clone());
    return obj;
  }

  equals(other: BatchedFrontEndMessageT): boolean {
    if (this.timestamp !== other.timestamp) return false;
    if (this.messages.length !== other.messages.length) return false;
    for (let i = 0; i < this.messages.length; i++) {
      const a = this.messages[i];
      const b = other.messages[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyBatchedFrontEndMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyFrontEndMessage);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "messages");
  } finally {
    verifier.popDepth();
  }
}

export function verifyRootAsBatchedFrontEndMessage(
  buf: DataView,
  opts?: flatbuffers.VerifierOptions,
): void {
  const verifier = new flatbuffers.Verifier(buf, opts);
  const tablePos = verifier.readUint32(0);
  verifyBatchedFrontEndMessage(verifier, tablePos);
}
